// extracted by mini-css-extract-plugin
export default {"players":"Players_players__+SxYy","show":"Players_show__uxFKG","green":"Players_green__jbgZ-","red":"Players_red__GqOgV"};